document.addEventListener('DOMContentLoaded', function () {
  const subnavLinks = document.querySelectorAll('.proxy-subnav a');
  const secondaryNavLinks = document.querySelectorAll(
    '.secondary-nav .list-menu .header__menu-item[data-link-text="menu:level2"], .secondary-nav .mega-menu__link[data-link-text="menu:level4:groupedLinks"], .secondary-nav .mega-menu__link[data-link-text="menu:level3:groupedLinks"], .secondary-nav .mega-menu__link[data-link-text="menu:level3:featuredLinks"]',
  );
  const megaMenuQuickLinks = document.querySelectorAll(
    '.secondary-nav .mega-menu__link[data-link-text="menu:level3:quickLinks"]',
  );
  let isProcessing = false;

  function getBreadcrumbData() {
    const breadcrumbItems = document.querySelectorAll('.breadcrumb__item a');
    const breadcrumbs = [];

    breadcrumbItems.forEach((item) => {
      const url = item.getAttribute('href');
      const text = item.textContent.trim();
      if (url && text && url !== '/') {
        breadcrumbs.push({
          url,
          text,
          handle: text
            .toLowerCase()
            .replace(/\s+/g, '-')
            .replace(/[^a-z0-9-]/g, ''),
        });
      }
    });
    return breadcrumbs;
  }

  function highlightFromBreadcrumbs() {
    const breadcrumbs = getBreadcrumbData();
    if (breadcrumbs.length === 0) return false;

    breadcrumbs.forEach((breadcrumb) => {
      secondaryNavLinks.forEach((link) => {
        const linkUrl = link.getAttribute('href');
        const linkText = link.textContent.trim();
        const linkSpan = link.querySelector('span');

        if (linkUrl && linkText.toLowerCase() === breadcrumb.text.toLowerCase() && linkUrl === breadcrumb.url) {
          if (linkSpan) linkSpan.classList.add('header__active-menu-item');
          else link.classList.add('mega-menu__link--active');
          highlightParentMenus(link);
        }
      });

      megaMenuQuickLinks.forEach((link) => {
        const linkUrl = link.getAttribute('href');
        const linkText = link.textContent.trim();
        if (linkUrl && linkText.toLowerCase() === breadcrumb.text.toLowerCase()) {
          link.classList.add('mega-menu__link--active');
          highlightParentMenus(link);
        }
      });
    });

    return true;
  }

  function waitForBreadcrumbs(callback, maxAttempts = 8, attempt = 1) {
    const breadcrumbItems = document.querySelectorAll('.breadcrumb__item a');
    if (breadcrumbItems.length > 0) {
      callback();
    } else if (attempt < maxAttempts) {
      setTimeout(() => {
        waitForBreadcrumbs(callback, maxAttempts, attempt + 1);
      }, 100);
    } else {
      callback();
    }
  }

  function observeBreadcrumbs(callback) {
    const breadcrumbContainer = document.querySelector('.breadcrumb, nav[aria-label*="breadcrumb"], .breadcrumbs');

    if (!breadcrumbContainer) {
      waitForBreadcrumbs(callback);
      return;
    }

    const observer = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        if (mutation.type === 'childList' || mutation.type === 'subtree') {
          const breadcrumbItems = document.querySelectorAll('.breadcrumb__item a');
          if (breadcrumbItems.length > 0) {
            observer.disconnect();
            callback();
            break;
          }
        }
      }
    });

    observer.observe(breadcrumbContainer, { childList: true, subtree: true });
    setTimeout(() => {
      observer.disconnect();
      callback();
    }, 1000);
  }

  function highlightParentMenus(link) {
    const secondaryNavContainer = link.closest('.secondary-nav .list-menu');
    if (secondaryNavContainer) {
      const parentHandle = secondaryNavContainer.getAttribute('data-parent');
      if (parentHandle) {
        document.querySelectorAll('.header__menu-item[data-link-text="menu:level1"]').forEach((item) => {
          if (item.getAttribute('data-id') === parentHandle) {
            const span = item.querySelector('span');
            if (span) span.classList.add('header__active-menu-item');
          }
        });
      }
    }

    const megaMenuList = link.closest('.mega-menu__list');
    if (megaMenuList) {
      const parentHandle = megaMenuList.getAttribute('data-parent');
      if (parentHandle) {
        const parentSecondaryLink = document.querySelector(
          `.secondary-nav .header__menu-item[href*="menu=${parentHandle}"]`,
        );
        if (parentSecondaryLink) {
          const span = parentSecondaryLink.querySelector('span');
          if (span) span.classList.add('header__active-menu-item');
        }

        document.querySelectorAll('.header__menu-item[data-link-text="menu:level1"]').forEach((item) => {
          if (item.getAttribute('data-id') === parentHandle) {
            const span = item.querySelector('span');
            if (span) span.classList.add('header__active-menu-item');
          }
        });
      }
    }
  }

  function handleize(str) {
    return str
      .toLowerCase()
      .trim()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }
  function handleNavigationHighlighting() {
    if (isProcessing) return;
    isProcessing = true;

    requestAnimationFrame(() => {
      try {
        subnavLinks.forEach((link) => {
          if (link.classList.contains('active')) {
            const linkParent = link.closest('.proxy-subnav')?.getAttribute('data-parent');
            if (linkParent) {
              document.querySelectorAll('.header__menu-item[data-link-text="menu:level1"]').forEach((item) => {
                if (item.getAttribute('data-id') === linkParent) {
                  item.querySelector('span')?.classList.add('header__active-menu-item');
                }
              });
            }
          }
        });

        const urlParams = new URLSearchParams(window.location.search);
        const clickedMenu = urlParams.get('menu');
        const clickedSubmenu = urlParams.get('submenu');
        const menuheader = urlParams.get('menuheader');

        if (clickedSubmenu) {
          secondaryNavLinks.forEach((link) => {
            if (link.getAttribute('data-link-text') !== 'menu:level2') {
              const linkUrl = new URL(link.href, window.location.origin);
              const linkParam = linkUrl.searchParams.get('submenu');

              link.classList.remove('mega-menu__link--active');

              if (linkParam === clickedSubmenu) {
                if (menuheader) {
                  let linkParentText = null;
                  const linkType = link.getAttribute('data-link-text');

                  if (linkType === 'menu:level4:groupedLinks' || linkType === 'menu:level3:featuredLinks') {
                    const parentGroup = link.closest('.mega-menu__list-item, .mega-menu__item, [class*="menu"]');
                    if (parentGroup) {
                      const linkParentElement = parentGroup.querySelector(
                        'a[data-link-text="menu:level3:groupedLinks"]',
                      );
                      if (linkParentElement) {
                        linkParentText = handleize(linkParentElement.textContent.trim());
                      }
                    }

                    if (!linkParentText) {
                      const nearbyGroupedLink = link.parentElement?.parentElement?.querySelector(
                        'a[data-link-text="menu:level3:groupedLinks"]',
                      );
                      if (nearbyGroupedLink) {
                        linkParentText = handleize(nearbyGroupedLink.textContent.trim());
                      }
                    }
                  } else if (linkType === 'menu:level3:groupedLinks') {
                    linkParentText = handleize(link.textContent.trim());
                  }

                  if (linkParentText === menuheader) {
                    link.classList.add('mega-menu__link--active');
                  }
                } else {
                  link.classList.add('mega-menu__link--active');
                }
              }
            }
          });

          sessionStorage.setItem('activeSubMenu', clickedSubmenu);
          sessionStorage.setItem('activeMenuParent', menuheader);
        }

        const activeSubMenu = sessionStorage.getItem('activeSubMenu');
        const activeMenuParent = sessionStorage.getItem('activeMenuParent');

        if (!clickedSubmenu && activeSubMenu) {
          secondaryNavLinks.forEach((link) => {
            if (link.getAttribute('data-link-text') !== 'menu:level2') {
              const linkHandle = handleize(link.textContent.trim());
              const linkUrl = new URL(link.href, window.location.origin);
              const linkParam = linkUrl.searchParams.get('menuheader');

              if (linkHandle === activeSubMenu && linkParam === activeMenuParent) {
                link.classList.add('mega-menu__link--active');
              } else {
                link.classList.remove('mega-menu__link--active');
              }
            }
          });
        }

        if (clickedMenu) {
          secondaryNavLinks.forEach((link) => {
            const linkUrl = new URL(link.href, window.location.origin);
            const linkParam = linkUrl.searchParams.get('menu');
            const linkSpan = link.querySelector('span');

            if (linkParam === clickedMenu) {
              if (linkSpan) {
                linkSpan.classList.add('header__active-menu-item');
                const linkSpanParent = link.closest('.secondary-nav .list-menu')?.getAttribute('data-parent');
                if (linkSpanParent) {
                  document.querySelectorAll('.header__menu-item[data-link-text="menu:level1"]').forEach((item) => {
                    if (item.getAttribute('data-id') === linkSpanParent) {
                      item.querySelector('span')?.classList.add('header__active-menu-item');
                    }
                  });
                }

                if (link.getAttribute('data-link-text') === 'menu:level2') {
                  sessionStorage.setItem('activeMenu', handleize(linkSpan.textContent.trim()));
                } else {
                  sessionStorage.removeItem('activeMenu');
                }
              }

              megaMenuQuickLinks.forEach((l) => l.classList.remove('mega-menu__link--active'));
            } else {
              if (linkSpan) linkSpan.classList.remove('header__active-menu-item');
              else link.classList.remove('mega-menu__link--active');
            }
          });
          if (!clickedSubmenu) {
            sessionStorage.removeItem('activeSubMenu');
          }
        } else {
          secondaryNavLinks.forEach((link) => {
            const linkSpan = link.querySelector('span') || link;
            if (linkSpan.classList.contains('header__active-menu-item')) {
              const linkSpanParent = link.closest('.secondary-nav .list-menu')?.getAttribute('data-parent');
              if (linkSpanParent) {
                document.querySelectorAll('.header__menu-item[data-link-text="menu:level1"]').forEach((item) => {
                  if (item.getAttribute('data-id') === linkSpanParent) {
                    item.querySelector('span')?.classList.add('header__active-menu-item');
                  }
                });
              }
              megaMenuQuickLinks.forEach((l) => l.classList.remove('mega-menu__link--active'));
            }

            const activeMenu = sessionStorage.getItem('activeMenu');
            if (link.getAttribute('data-link-text') === 'menu:level2' && activeMenu) {
              if (handleize(link.textContent.trim()) === activeMenu) {
                linkSpan.classList.add('header__active-menu-item');
                link.classList.remove('mega-menu__link--active');
              } else {
                linkSpan.classList.remove('header__active-menu-item');
              }
            }
          });

          highlightFromBreadcrumbs();
        }

        megaMenuQuickLinks.forEach((link) => {
          if (link.classList.contains('mega-menu__link--active')) {
            const linkParent = link.closest('.secondary-nav .mega-menu__list')?.getAttribute('data-parent');
            if (linkParent) {
              document.querySelectorAll('.header__menu-item[data-link-text="menu:level1"]').forEach((item) => {
                if (item.getAttribute('data-id') === linkParent) {
                  item.querySelector('span')?.classList.add('header__active-menu-item');
                }
              });
            }
          }
        });

        const url = new URL(window.location);
        url.searchParams.delete('menu');
        url.searchParams.delete('submenu');
        url.searchParams.delete('menuheader');
        window.history.replaceState({}, document.title, url.toString());
        document.dispatchEvent(new Event('menuUpdated'));
      } finally {
        isProcessing = false;
      }
    });
  }

  const urlParams = new URLSearchParams(window.location.search);
  if (urlParams.has('menu') || urlParams.has('submenu') || urlParams.has('menuheader')) {
    handleNavigationHighlighting();
  } else {
    observeBreadcrumbs(handleNavigationHighlighting);
  }

  window.addEventListener('pageshow', function () {
    handleNavigationHighlighting();
  });
});
